<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">팝업/배너관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">팝업관리</p>
          <ul class="depth">
            <li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
            <li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">팝업 조회</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                팝업 조회 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목</th>
                  <td colspan="3">{{ popupInfo.title }}</td>
                </tr>
                <tr>
                  <th scope="row">게시기간</th>
                  <td colspan="3">
                    {{ popupInfo.openDate | ptDateFormat }} ~ {{ popupInfo.closeDate | ptDateFormat }}
                  </td>
                </tr>
                <tr>
                  <th scope="row">사용여부</th>
                  <td>사용함</td>
                  <th scope="row">위치</th>
                  <td>X : {{ popupInfo.posX }} &nbsp;&nbsp; Y : {{ popupInfo.posY }}</td>
                </tr>
                <tr>
                  <th scope="row">크기</th>
                  <td colspan="3">가로 : {{ popupInfo.sizeX }} &nbsp;&nbsp; 세로 : {{ popupInfo.sizeY }}</td>
                </tr>
                <tr>
                  <th scope="row">링크주소</th>
                  <td colspan="3">{{ popupInfo.linkUrl }}</td>
                </tr>
                <tr>
                  <th scope="row">팝업내용</th>
                  <td colspan="3">
                    <pre name="" id="">
                                            <div v-html="popupInfo.popupContents"></div>
                                        </pre>
                  </td>
                </tr>
                <tr v-if="attachList.length!=0">
                  <tr v-for="(item, idx) in attachList" :key="idx">
                    <th scope="row">첨부파일</th>
                    <td colspan="3"><a @click="downloadAttachFile(item.filePath, item.saveNm, item.viewNm, item.fileExt, item.repoId)" class="fileName">{{ item.viewNm }}</a></td>
                  </tr>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('popuplist')">목록</button>
          <button class="btn gray" @click="deleteConfirm">삭제</button>
          <button class="btn blue" @click="update">수정</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      popupId: '',
      popupInfo: {},
      attachList: [],
    };
  },

  mounted() {
    const popupId = this.$route.query.popupId;
    if (!popupId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/noticemanagement');
    }
    this.popupId = popupId;
    this.findPopup();
  },

  methods: {
    async findPopup() {
      const res = await axios('get', '/api/admin/popup/view.json', {
        popupId: this.popupId,
      });
      this.popupInfo = res.data.popupView;
      this.attachList = res.data.attachList || [];
    },

    update() {
      const params = {
        popupId: this.popupInfo.popupId,
        title: this.popupInfo.title,
        openDate: this.$options.filters.ptDateFormat(this.popupInfo.openDate),
        closeDate: this.$options.filters.ptDateFormat(this.popupInfo.closeDate),
        useYn: this.popupInfo.useYn,
        posX: this.popupInfo.posX,
        posY: this.popupInfo.posY,
        sizeX: this.popupInfo.sizeX,
        sizeY: this.popupInfo.sizeY,
        linkUrl: this.popupInfo.linkUrl,
        popupContents: this.popupInfo.popupContents,
      };

      this.$router.push({
        name: 'popupupdate',
        params: { data: params },
      });
    },

    async deleteBtn() {
      let apiParams = new FormData();
      apiParams.append('popupId', this.popupId);
      await axios('post', '/api/admin/popup/delete.json', apiParams);
      await this.$router.push('popuplist');
    },

    deleteConfirm() {
      this.$confirm({
        message: `삭제하시겠습니까?`,
        button: {
          no: '아니오',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.deleteBtn();
          }
        },
      });
    },

    downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
			location.href = "/api/admin/popup/download.json?filePath=" + filePath + "&saveNm=" + saveNm + "&viewNm=" + viewNm + "&fileExt=" + fileExt + "&repoId=" + repoId;
		},
  },
};
</script>
